export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.6-1605.18",
  commitId: "f3b2412c079ae700103fc549c471a4e8d82a1fd1",
  commitTime: "2026-05-06T16:05:18.000Z",
});
